module.exports = __webpack_public_path__ + "img/ng.svg";